import { AppModule } from './app/app.module';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { ersConstants } from '@rcs/utils';
import { environment } from './environments/environment';
import { startGoogleMapsLoad } from './app/base/google-maps/google-maps.loader';
import { toInternalModuleUrl } from '@rcs/utils';

// NOTE: AG Grid/Charts Enterprise registration is no longer done here at
// bootstrap — it would pull the entire enterprise bundle into the initial
// chunk. It is now registered lazily by the first grid that mounts (the
// <ers-grid> wrapper, or self-registering feature components), keeping it out
// of the critical-path bundle.

// Capture the intended URL from the browser address bar BEFORE Angular routing
// begins. This is needed for "Open in new window" scenarios where the app would
// otherwise redirect to the MRU URL, overriding the user's intended destination.
(function captureIntendedUrl() {
  const path = toInternalModuleUrl(window.location.pathname);
  const search = window.location.search;
  const fullPath = path + search;

  // Only save if it looks like a real ERS app route, not an auth flow
  const isAuthRoute =
    path.startsWith('/login') ||
    path.startsWith('/oauth') ||
    path.startsWith('/go-oauth') ||
    path.startsWith('/unauthorized') ||
    path.startsWith('/defaults-verify') ||
    path.startsWith('/forgetpassword') ||
    path.startsWith('/change-password');

  // These routes are treated as "default landing" — MRU should still apply
  const isDefaultLanding =
    path === '/' ||
    path === '' ||
    path === '/ers' ||
    path === '/ers/' ||
    path === '/ers/dashboard' ||
    path.startsWith('/ers/dashboard/');

  if (!isAuthRoute && !isDefaultLanding) {
    sessionStorage.setItem(ersConstants.INTENDED_NAV_URL_KEY, fullPath);
  } else {
    sessionStorage.removeItem(ersConstants.INTENDED_NAV_URL_KEY);
  }
}());

// Fetch the Maps key in the background — not awaited, so app start is never delayed.
startGoogleMapsLoad(environment.apiUrl.projectManagement);

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));